import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Download, X, Share } from "lucide-react";

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);
const HIDE_ON = ["/join", "/app"];

export function InstallApp() {
  const { pathname } = useLocation();
  const [prompt, setPrompt] = useState(() => window.__fxInstall || null);
  const [ios, setIos] = useState(false);
  const [closed, setClosed] = useState(() => localStorage.getItem("fx_install_closed") === "1");

  useEffect(() => {
    if (isStandalone()) {
      return;
    }
    const onPrompt = () => setPrompt(window.__fxInstall);
    window.addEventListener("fx-installable", onPrompt);
    window.addEventListener("appinstalled", () => setPrompt(null));
    if (isIOS()) {
      setIos(true);
    }
    return () => window.removeEventListener("fx-installable", onPrompt);
  }, []);

  if (closed || HIDE_ON.includes(pathname) || (!prompt && !ios)) return null;
  const close = () => { localStorage.setItem("fx_install_closed", "1"); setClosed(true); };
  const install = async () => {
    prompt.prompt();
    await prompt.userChoice;
    setPrompt(null);
  };

  return (
    <div data-testid="install-app-banner" className="fixed bottom-20 md:bottom-4 left-4 right-4 sm:left-auto sm:w-96 z-[60] flex items-center gap-3 px-4 py-3 border border-gold/40 shadow-2xl animate-in fade-in slide-in-from-bottom-4 duration-500" style={{ background: "rgba(12,12,14,0.92)", backdropFilter: "blur(16px)" }}>
      <img src="/icons/icon-192.png" alt="" className="w-10 h-10" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-white">Fateh FX App install karein</div>
        {prompt ? (
          <div className="text-[11px] text-slate-400">Home screen pe icon, full-screen aur fast.</div>
        ) : (
          <div className="text-[11px] text-slate-400 flex items-center gap-1 flex-wrap">Safari me <Share size={11} /> Share → "Add to Home Screen"</div>
        )}
      </div>
      {prompt && (
        <button data-testid="install-app-btn" onClick={install} className="flex items-center gap-1.5 px-3 py-2 bg-gold text-black text-xs font-bold hover:brightness-110 transition-[filter] duration-200">
          <Download size={14} />Install
        </button>
      )}
      <button data-testid="install-app-close" onClick={close} className="text-slate-500 hover:text-white transition-colors duration-200"><X size={16} /></button>
    </div>
  );
}
